import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';
import { observer } from 'mobx-react';

import FirebaseStore from 'stores/FirebaseStore';
import { secondsToTime } from 'utils/helpers';
import useInterval from 'hooks/useInterval';
import ThemeService from 'themes/ThemeService';
import { MINUTE_AS_SECONDS, SECOND_AS_MILLISECONDS } from 'enum/timeFormat';

import styles from './BoostAnimation.css';


const DEFAULT_DURATION_MINUTES = 5;
const DEFAULT_EXTENDED_DURATION_MINUTES = 25;
const ANIMATION_DURATION_SECONDS = DEFAULT_DURATION_MINUTES * MINUTE_AS_SECONDS;

function BoostAnimation({ isDesktop, isBroadcaster }) {
  const [boostTimer, setBoostTimer] = useState(null);
  const [progress, setProgress] = useState(0);
  const { boostRemainingTime, isBanned, userKickedStatus } = FirebaseStore;
  const duration = window.BOOSTED_ROOM_DURATION_MINUTES || DEFAULT_DURATION_MINUTES;
  const extendedDuration = window.BOOSTED_ROOM_EXTENDED_DURATION_MINUTES || DEFAULT_EXTENDED_DURATION_MINUTES;
  const totalDuration = duration + extendedDuration;

  useInterval(() => {
    const timeLeft = moment(boostRemainingTime).add(extendedDuration, 'minutes').diff(moment(), 'seconds');
    const timePassed = (totalDuration * MINUTE_AS_SECONDS) - timeLeft;
    const increment = 100 / ANIMATION_DURATION_SECONDS;
    const percentage = increment * timePassed;
    if (percentage >= 100) {
      setProgress(100);
    } else {
      setProgress(percentage);
    }
    const formatted = secondsToTime(timePassed);
    setBoostTimer(formatted);
  }, [boostRemainingTime ? SECOND_AS_MILLISECONDS : null]);

  const wrapperClasses = classNames({
    [styles.wrapper]: true,
    [styles.wrapperDesktop]: isDesktop,
    [styles.broadcasterBoost]: isBroadcaster,
    [styles.hide]: !boostTimer,
  });

  const kickedOrBanned = isBanned || userKickedStatus;

  return (
    <div>
      {!kickedOrBanned && (
        <Fragment>
          <div className={wrapperClasses}>
            <div className={styles.bar} style={{ width: `${progress}%` }} />
            <div className={styles.content}>
              <img alt="boostIcon" src={ThemeService.theme.boost.icon} />
              <span>{boostTimer}</span>
            </div>
          </div>
        </Fragment>
      )}
    </div>
  );
}

BoostAnimation.propTypes = {
  isBroadcaster: PropTypes.bool,
  isDesktop: PropTypes.bool,
};

BoostAnimation.defaultProps = {
  isBroadcaster: false,
  isDesktop: false,
};

export default observer(BoostAnimation);
